function initialState() {
  return {
    portalLiveStats: null,
  };
}

let state = initialState();

export { initialState, state };
